function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { urlAccountLogin } from "scripts/constants/urls";
import { qs } from "scripts/data_utils/domHelpers";
import emailValidation from "scripts/data_utils/email_validation";
import formDataFetch from "scripts/data_utils/formDataFetch";
import { throwError } from "scripts/data_utils/throwError";
import { getGlobal } from "scripts/utils/global";
import PopupPrompt from "./popup_prompt";

class LoginPopup extends PopupPrompt {
  constructor(el, values) {
    super(el);

    _defineProperty(this, "toggleUnMask", () => {
      const {
        passwordField
      } = this.fields;

      if (passwordField.type === "password") {
        passwordField.type = "text";
        this.unmask.classList.add("open");
      } else {
        passwordField.type = "password";
        this.unmask.classList.remove("open");
      }
    });

    _defineProperty(this, "validationForm", e => {
      e.preventDefault();

      if (!this.fields.emailField.value) {
        this.showFieldError(this.form, "email", "Введите e-mail");
        return;
      }

      if (!emailValidation(this.fields.emailField.value)) {
        this.showFieldError(this.form, "email", "Не похоже на e-mail");
        return;
      }

      if (!this.fields.passwordField.value) {
        this.showFieldError(this.form, "password", "Введите пароль");
        return;
      }

      this.sendForm();
    });

    _defineProperty(this, "sendForm", () => {
      const data = {
        email: this.fields.emailField.value,
        password: this.fields.passwordField.value
      };
      this.hideAllFieldsError();
      this.disableSubmitButton();
      formDataFetch(urlAccountLogin, data).then(response => {
        if (response.errors.length > 0) {
          this.showAllErrors(response.errors);
          this.enableSubmitButton();
        } else {
          var _getGlobal;

          (_getGlobal = getGlobal("dataLayer")) === null || _getGlobal === void 0 ? void 0 : _getGlobal.push({
            event: "Authorization"
          });
          window.location = window.app.urls.redirectUrl ? window.app.urls.redirectUrl : response.result.redirect_url;
        }
      }).catch(error => {
        throwError({
          error
        });
        this.enableSubmitButton();
      });
    });

    _defineProperty(this, "body", `
  <div class="modal-wrapper__title">
    Вход
  </div>

  <form class="js-form" method="post">
    <label for="email" class="text-input">
    <span class="text-input__text">Ваша электронная почта</span>
      <input class="text-input__input js-email" type="email" value=""/>
      <div class="modal-wrapper__error js-error-container form-error-email" style="display:none"></div>
    </label>

    <label for="password" class="text-input">
      <span class="text-input__text">Ваш пароль
        <span tabindex="-1" class="link link--underline text-input__label-link js-show-password-reset-popup">Забыли?</span>
      </span>
      <span class="modal-wrapper__input-container">
        <input class="text-input__input js-password" type="password"/>
        <button class="modal-wrapper__unmask js-unmask" type="button"></button>
      </span>
      <div class="modal-wrapper__error js-error-container form-error-password" style="display:none"></div>
    </label>

    <button class="button button--big button--primary js-submit">Войти</button>
    <div class="button button--big button--default js-show-registration-popup">Зарегистрироваться</div>
    <div>
      <div class="modal-wrapper__error js-error-container js-__all__ form-error-__all__" style="display:none"></div>
    </div>
    <div class="modal-wrapper__footer-link">
      При регистрации вы соглашаетесь <br>
      с <a href="/offer/" target="_blank" rel="noreferrer noopener" class="link link--underline">публичной офертой</a>.
    </div>
  </form>
  `);

    this.init();
    this.form = qs(".js-form", this.dialogBox);
    this.button = qs(".js-submit", this.form);
    this.loader = document.createElement("div");
    this.loader.classList.add("loader-round");
    this.form.addEventListener("submit", this.validationForm);
    this.fields = {
      emailField: qs(".js-email", this.form),
      passwordField: qs(".js-password", this.form)
    };
    this.unmask = qs(".js-unmask", this.form);
    this.fields.emailField.value = values.email;
    this.fields.passwordField.value = values.password;
    this.unmask.addEventListener("mousedown", this.toggleUnMask);
    this.hideErrorOnClickOnField();
  }

}

export default LoginPopup;